import { Link } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

interface SectionLogoProps {
  /**
   * Logo image
   */
  logo?: any;
  /**
   * Link to redirect on click
   */
  logoLink?: string;
  /**
   * Height of the container
   */
  height?: number;
  /**
   * Bottom space for container
   */
  marginBottom?: number;
  /**
   * Top space for container
   */
  marginTop?: number;
  /**
   * Show crop version of the logo
   */
  small?: boolean;
  /**
   * Additional Logo Container Class
   */
  additionalLogoContainerClasses?: string;
  /**
   * Section Logo test id
   */
  testId?: string;
}

export const SectionLogo = ({
  logo,
  logoLink,
  height = 73,
  marginBottom = 46,
  marginTop = 0,
  small = false,
  additionalLogoContainerClasses = '',
  testId = '',
}: SectionLogoProps) => {
  return (
    <div
      className={twMerge(
        'overflow-hidden pl-4',
        additionalLogoContainerClasses,
      )}
      style={{
        height: height,
        marginBottom: marginBottom,
        marginTop: marginTop,
      }}
      {...getTestProps(testId, 'container')}
    >
      <div
        className={twMerge(
          'flex items-center overflow-hidden h-full',
          'transition-all ease-linear duration-fast',
          small ? 'w-10' : 'w-[154px]',
        )}
        {...getTestProps(testId, 'wrap')}
      >
        {logoLink ? (
          <Link
            to={logoLink}
            className="cursor-pointer"
            rel="noreferrer"
            {...getTestProps(testId, 'link')}
          >
            {logo}
          </Link>
        ) : (
          <span>{logo}</span>
        )}
      </div>
    </div>
  );
};
